import { useState } from 'react';
import { Minus, Moon, Plus, Search, Sun } from 'lucide-react';
import type { Language } from '../i18n';
import { interactiveCopy } from '../studio-interactive-copy';
import { builderCopy } from '../studio-builder-copy';

export type StudioTheme = 'light' | 'dark';

export function ThemeToggle({ language, theme, onToggle }: { language: Language; theme: StudioTheme; onToggle: () => void }) {
  const c = builderCopy[language];
  return <button className="studio-theme-toggle" type="button" role="switch" aria-checked={theme === 'dark'} aria-label={c.theme} onClick={onToggle}>
    <span className="studio-theme-toggle__track" aria-hidden="true"><Sun size={14} /><Moon size={14} /><span /></span>
    <span>{theme === 'dark' ? c.dark : c.light}</span>
  </button>;
}

export function StudioFaq({ language }: { language: Language }) {
  const c = interactiveCopy[language].faq;
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState<number | null>(0);
  const items = c.items.map((item, index) => ({ ...item, index })).filter((item) => `${item.question} ${item.answer}`.toLocaleLowerCase(language).includes(query.trim().toLocaleLowerCase(language)));

  return <section className="studio-faq" id="faq"><div className="studio-wrap studio-faq__layout">
    <div data-reveal><span className="studio-kicker">{c.label}</span><h2>{c.title}</h2></div>
    <div data-reveal>
      <label className="studio-faq__search"><Search size={19} aria-hidden="true" /><input type="search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder={c.search} aria-label={c.search} /></label>
      <div className="studio-faq__list">{items.length ? items.map((item) => <div className="studio-faq__item" key={item.index}>
        <h3><button type="button" aria-expanded={open === item.index} aria-controls={`studio-faq-answer-${item.index}`} onClick={() => setOpen(open === item.index ? null : item.index)}>{item.question}{open === item.index ? <Minus size={19} aria-hidden="true" /> : <Plus size={19} aria-hidden="true" />}</button></h3>
        <p id={`studio-faq-answer-${item.index}`} className="studio-faq__answer" hidden={open !== item.index}>{item.answer}</p>
      </div>) : <p className="studio-faq__none">{c.noResults}</p>}</div>
    </div>
  </div></section>;
}
